// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"settingsAccountView_wrapper__1IZo4","title":"settingsAccountView_title__FbQhC","content":"settingsAccountView_content__3FTuY"};